import React, { Component } from 'react';
import componentLookUp from '../../../shared/core/components.map';

type FsRecentsPagePropsType = {
    components: string[]
}

type FsRecentsPageState = {
    isLoaded: boolean,
    error: null,
    data: any
}

class FsRecentsPage extends Component<FsRecentsPagePropsType, FsRecentsPageState> {
    render() {
        return(
            <>
                { this.props.components.map( (comp, index) => 
                    <div key={index}>{ componentLookUp(comp) }</div>
                )}
            </>
        )
    }
}

export default FsRecentsPage;